import React from 'react';
import { Col, Form } from 'react-bootstrap';
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import { sidSelectStyles } from '../../Util/sidSelectStyles';

/*
 * Campi delle schede di modifica delle anagrafiche (super admin). Etichetta sopra il campo, niente testo dentro
 * (docs/sportid-ui.md cap. 3), tendine react-select con sidSelectStyles, sì/no come interruttore.
 * Ogni campo sta in una colonna: due per riga, uno per riga sul telefono (col-sm-6).
 * Gli id cominciano con «sa-»: li usa segnalaMancanti per evidenziare i dati da sistemare.
 */

const nessunRisultato = () => 'Nessun risultato';

export const Testo = ({ id, etichetta, valore, onChange, tipo = 'text', larghezza = 6, ...altro }) => (
    <Col sm={larghezza}>
        <Form.Label htmlFor={`sa-${id}`}>{etichetta}</Form.Label>
        <Form.Control id={`sa-${id}`} type={tipo} value={valore ?? ''} onChange={(e) => onChange(e.target.value)} {...altro} />
    </Col>
);

export const TestoLungo = ({ id, etichetta, valore, onChange }) => (
    <Col xs={12}>
        <Form.Label htmlFor={`sa-${id}`}>{etichetta}</Form.Label>
        <Form.Control as="textarea" rows={4} id={`sa-${id}`} value={valore ?? ''} onChange={(e) => onChange(e.target.value)} />
    </Col>
);

/** Valore che non si modifica, con lo stesso aspetto di un campo bloccato. */
export const SolaLettura = ({ etichetta, valore, larghezza = 6 }) => (
    <Col sm={larghezza}>
        <Form.Label as="span">{etichetta}</Form.Label>
        <div className="sid-readonly-value">{valore || '-'}</div>
    </Col>
);

/** Una voce fra poche (non si svuota: il server accetta solo i valori dell'elenco). */
export const Tendina = ({ id, etichetta, opzioni, valore, onChange, larghezza = 6 }) => {
    // Un valore salvato che non e' nell'elenco si mostra comunque, con il suo codice
    const tutte = valore && !opzioni.some((o) => o.value === valore) ? [...opzioni, { value: valore, label: valore }] : opzioni;
    return (
        <Col sm={larghezza}>
            <Form.Label htmlFor={`sa-${id}`}>{etichetta}</Form.Label>
            <Select
                inputId={`sa-${id}`}
                styles={sidSelectStyles}
                options={tutte}
                value={tutte.find((o) => o.value === valore) || null}
                onChange={(o) => onChange(o ? o.value : '')}
                isSearchable={tutte.length > 8}
                placeholder=""
                noOptionsMessage={nessunRisultato}
            />
        </Col>
    );
};

/** Piu' voci da un elenco fisso. */
export const Elenco = ({ id, etichetta, opzioni, valori, onChange, larghezza = 6 }) => {
    const extra = (valori || []).filter((v) => !opzioni.some((o) => o.value === v)).map((v) => ({ value: v, label: v }));
    const tutte = [...opzioni, ...extra];
    return (
        <Col sm={larghezza}>
            <Form.Label htmlFor={`sa-${id}`}>{etichetta}</Form.Label>
            <Select
                inputId={`sa-${id}`}
                isMulti
                styles={sidSelectStyles}
                options={tutte}
                value={(valori || []).map((v) => tutte.find((o) => o.value === v))}
                onChange={(scelte) => onChange((scelte || []).map((o) => o.value))}
                placeholder=""
                noOptionsMessage={nessunRisultato}
            />
        </Col>
    );
};

/** Piu' voci scritte a mano (farmaci, malattie ereditarie): si scrive e si preme Invio. */
export const ElencoLibero = ({ id, etichetta, valori, onChange, larghezza = 6 }) => (
    <Col sm={larghezza}>
        <Form.Label htmlFor={`sa-${id}`}>{etichetta}</Form.Label>
        <CreatableSelect
            inputId={`sa-${id}`}
            isMulti
            styles={sidSelectStyles}
            options={[]}
            components={{ DropdownIndicator: null }}
            value={(valori || []).map((v) => ({ value: v, label: v }))}
            onChange={(scelte) => onChange((scelte || []).map((o) => o.value))}
            formatCreateLabel={(t) => `Aggiungi «${t}»`}
            isValidNewOption={(t) => t.trim().length > 0 && !(valori || []).includes(t.trim())}
            getNewOptionData={(t) => ({ value: t.trim(), label: t.trim() })}
            placeholder=""
            noOptionsMessage={() => 'Scrivi e premi Invio'}
        />
    </Col>
);

/** Sì / no. */
export const Interruttore = ({ id, etichetta, valore, onChange, larghezza = 6 }) => (
    <Col sm={larghezza} className="d-flex align-items-end">
        <div className="sid-switch-row">
            <Form.Check type="switch" id={`sa-${id}`} label={etichetta} checked={!!valore} onChange={(e) => onChange(e.target.checked)} />
        </div>
    </Col>
);
